import * as pako from 'pako'; //NOSONAR

export function decompressBody(compressedBody: string) {
    const strData = atob(compressedBody);
    const charData = strData.split('').map((x) => x.charCodeAt(0));
    const binData = new Uint8Array(charData);
    const data = pako.inflate(binData);
    console.log(data);
    const decompressedBody = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint16Array(data))))); // NOSONAR
    console.log('DecompressedBody is', decompressedBody);
    return decompressedBody;
}



// WEBPACK FOOTER //
// ./src/app/shared/util/Decompress.ts